import { ref, Ref } from "vue";

class Queue<T> {
  version: Ref<number>;
  name: string;

  _getName(): string {
    return 'queue__' + this.name;
  }

  getQueue(): Array<T> {
    const name = this._getName();
    return JSON.parse(localStorage[name] || '[]');
  }

  peek(): T | undefined {
    return this.getQueue()[0];
  }

  mostRecentlyAdded(): T | undefined {
    return this.getQueue()[this.getQueue().length - 1];
  }

  commitQueue(queue: Array<T>) {
    const name = this._getName();
    localStorage[name] = JSON.stringify(queue);
    this.version.value += 1;
  }

  push(element: T) {
    const queue = this.getQueue();
    queue.push(element);
    this.commitQueue(queue);
  }

  pop(): T | undefined {
    const queue = this.getQueue();
    const element = queue.shift();
    this.commitQueue(queue);
    return element;
  }

  count(): number {
    return this.getQueue().length;
  }

  constructor(name: string) {
    this.version = ref(0);
    this.name = name;
  }
}


export { Queue }
